var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myipt"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"numer-tool",attrs:{"min":_vm.min,"max":_vm.max,"type":"number"},domProps:{"value":(_vm.val)},on:{"input":[function($event){if($event.target.composing)return;_vm.val=$event.target.value},_vm.inputNumber]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }